export const chartPalette = {
  baseline: "#64748b",
  reporting: "#3b82f6",
  target: "#00c951",
  targetLine: "#e7000b",
  line: "#0ea5e9",
  grid: "#e5e7eb",
};

const totalsBarColors = {
  Baseline: chartPalette.baseline,
  Reporting: chartPalette.reporting,
  Target: chartPalette.target,
};

export const getTotalsBarColor = (type) =>
  totalsBarColors[type] || chartPalette.baseline;

const totalsBarHoverColors = {
  Baseline: "rgba(100, 116, 139, 0.12)",
  Reporting: "rgba(59, 130, 246, 0.12)",
  Target: "rgba(0, 201, 81, 0.12)",
};

export const getTotalsBarHoverColor = (type) =>
  totalsBarHoverColors[type] || totalsBarHoverColors.Baseline;

export const getChartIds = (prefix) => ({
  lineFillId: `${prefix}-line-fill`,
  barPatternId: `${prefix}-bar-pattern`,
});

export const ChartDefs = ({
  lineId,
  barPatternId,
  lineColor = chartPalette.line,
  barColor = chartPalette.reporting,
}) => (
  <defs>
    <linearGradient id={lineId} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor={lineColor} stopOpacity="0.25" />
      <stop offset="100%" stopColor={lineColor} stopOpacity="0" />
    </linearGradient>
    <pattern
      id={barPatternId}
      patternUnits="userSpaceOnUse"
      width="6"
      height="6"
    >
      <rect width="6" height="6" fill={barColor} opacity="0.12" />
      <path d="M0 6 L6 0" stroke={barColor} strokeWidth="1" opacity="0.35" />
    </pattern>
  </defs>
);
